export enum PrivacyUser {
    CONTITOLARE = 'PRIVACY_CONTITOLARE',
    NON_CONTITOLARE = 'PRIVACY_NON_CONTITOLARE',
    UNICA = 'PRIVACY_UNICA',
    BLUESKY = 'PRIVACY_BLUESKY',
}